const $ = jQuery;
let updatePosition = function(Item){
	Item.position = $(Item).offset();
	var s = $(window).scrollTop();
	if ($(window).width()>768){
		$(Item).css('backgroundPosition', "center "+((Item.position.top-s)/10)+'px');
	}

	$(Item).css({
		backgroundAttachment: 'fixed',
		backgroundSize: 'cover',
		transform:'translate3d(0,0,0)',
		transition: "backgroundPosition .3s ease-in-out"
	});

	if (Item.modes===undefined){
		Item.modes = $(Item).attr('data-parallax').split(',');
	}
	var calcOpacity = function(s,p1,p2){
		if (s<p1){
			return 1;
		}
		if (s>p2){
			return 0;
		}
		return 1-(s-p1)/(p2-p1);
	}
	if (Item.modes.indexOf('fade')!= -1){

		var opacity = calcOpacity(s,Item.position.top,  Item.position.top+$(Item).height()*1/2);
		$(Item).css('opacity', opacity);
	}

	if (Item.modes.indexOf('grayscale')!=-1){
		var grayscale = 100*calcOpacity(s,Item.position.top-300,  Item.position.top);
		$(Item).css('filter', 'grayScale('+grayscale+'%)')
	}
	if (Item.modes.indexOf('fadecaption')!= -1){

		var opacity = 1 - calcOpacity(s,
			Item.position.top-$(Item).height(),  
			Item.position.top-$(Item).height()*1/2);
		$(Item).parent().find('figcaption').css('opacity', opacity);
	}


}

let updatePositions = ()=>{
	var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	if (iOS) return;
	$('[data-parallax]').each(function(){
		updatePosition(this);
	});
}
$(document).ready(updatePositions);
$(window).scroll(updatePositions)
$(window).resize(updatePositions)

window.updateParallax = updatePositions;